export default "__VITE_ASSET__Dbmb4rQ___"